import { lazy } from "react";
import {
  DatePicker,
  Dropdown,
  FilePicker,
  GroupRenderer,
  Input,
} from "stories";
import { RadioGroupList } from "stories/components/radioGroup/RadioGroup";
import { ConditionalFormRenderer } from "../../../../../../../stories/components/FormRenderer/ConditionalFormRenderer";
import { staticEntities } from "../constants";
import { getEventItemModel } from "../eventChart/EventItem";

const EventChart = lazy(() => import("../eventChart/EventChart"));

const getScheduleFields = (type, label) => {
  return [
    [
      {
        renderAsFormItem: false,
        component: () => {
          return <div className="section-title fw-bold">{label}</div>;
        },
      },
    ],
    [
      {
        name: `${type}.gantt_chart`,
        component: RadioGroupList,
        props: {
          label: "Do you have a Gantt Chart?",
          list: staticEntities.booleanList,
        },
      },
      {},
    ],
    [
      {
        renderAsFormItem: false,
        component: ConditionalFormRenderer,
        props: {
          conditionFieldName: `${type}.gantt_chart`,
          conditionalFields: {
            true: [
              [
                {
                  name: `${type}.filename`,
                  component: FilePicker,
                  props: {
                    label: "Gantt Chart",
                    type: "file",
                  },
                },
                {},
              ],
            ],
            false: [
              [
                {
                  renderAsFormItem: false,
                  component: EventChart,
                  props: {
                    type: `${type}`,
                  },
                },
              ],
              [
                {
                  name: `${type}.events`,
                  renderAsFormItem: false,
                  component: GroupRenderer,
                  props: {
                    title: "Events",
                    itemPrefix: "Event",
                    addButtonText: "Add Event",
                    fields: [
                      [
                        {
                          name: "name",
                          component: Input,
                          props: {
                            label: "Name",
                          },
                        },
                        {},
                      ],
                      [
                        {
                          name: "start_date",
                          component: DatePicker,
                          props: {
                            label: "Start Date",
                          },
                        },
                        {
                          name: "end_date",
                          component: DatePicker,
                          props: {
                            label: "End Date",
                          },
                        },
                      ],
                      [
                        {
                          name: "status",
                          component: Dropdown,
                          props: {
                            label: "Status",
                            list: staticEntities.eventStatusList,
                          },
                        },
                        {},
                      ],
                    ],
                    getModelItem: getEventItemModel,
                  },
                },
              ],
            ],
          },
        },
      },
    ],
  ];
};

export const scheduleFormFields = [
  ...getScheduleFields("development_schedule", "Development Schedule"),
  ...getScheduleFields("construction_schedule", "Construction Schedule"),
];
